import { Slot, Redirect, usePathname } from 'expo-router';
import { useAuthStore } from '@/store';
import useGlobalStyles from '@/hooks/useGlobalStyles';

export default function AuthLayout() {
  const isTokenExpired = useAuthStore(state => state.isTokenExpired);
  const token = useAuthStore(state => state.token);
  const isGhost = useAuthStore(state => state.user?.flags?.isGhost);
  const pathname = usePathname();

  useGlobalStyles();

  // A ghost (guest) session has a valid token but is not a real logged-in
  // account. Guests are allowed to browse the platform and to reach the
  // auth-flow routes (login, signup). Only a real logged-in account is
  // redirected away from those pages — otherwise a guest who enters their
  // password would be bounced home before the MFA prompt renders.
  const isAuthenticated = token && !isTokenExpired() && !isGhost;

  // The MFA challenge (/login-authorize) is the second step of the login
  // flow and is gated by a short-lived signed ticket, not by the session.
  // It must stay reachable for ANY session state (logged-out, guest, or even
  // a stale authenticated one). Redirecting a user away mid-challenge
  // silently bypasses 2FA and drops them into the guest experience.
  const isMfaRoute = pathname === '/login-authorize';

  if (isAuthenticated && pathname !== '/verify-email' && !isMfaRoute) {
    return <Redirect href="/" />;
  }

  // Otherwise, render the auth pages (also the path for logged-out/guest users)
  return <Slot />;
} 